import anime from 'animejs';
import hoverintent from './hoverintent.js';

export function initSlideBanners() {

    // Load videos from data-video attribute
    for(let media of document.querySelectorAll(".slideBanner__media")){
        if(media.dataset.video){
            let html = media.dataset.video;
            html = html.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');
            html = html.replace(/preload\s*=\s*["']auto["']/gi, 'preload="none"');
            html = html.replace(/\s*autoplay\s*/gi, ' ');
            media.insertAdjacentHTML('beforeend', html);
        }
    }

    if(window.innerWidth <= 768) {
        return;
    }

    // Animation timing constants (in milliseconds)
    const SUMMARY_FADE_DURATION = 400;
    const SUMMARY_FADE_DURATION_OUT = 200;
    const SUMMARY_FADE_DELAY = 800;
    const HOVERINTENT_DURATION = 200;

    const shouldReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    for( let slideBanners of document.querySelectorAll( '.slideBanners' ) ) {
        const cards = slideBanners.querySelectorAll('.slideBanner');
        if( !cards.length ) {
            return;
        }
        for( let card of cards ) {
            const video = card.querySelector('video');
            const summary = card.querySelector('.slideBanner__summary');
            if (!video) return;

            let timeline;

            video.autoplay = false;

            const play = () => {
                if (shouldReduceMotion) return; // respect user preference
                const p = video.play();
                if (p && typeof p.catch === 'function') p.catch(() => {/* ignore */});

                // Kill any existing timeline
                if (timeline) timeline.pause();

                // Create timeline: first expand banner, then show summary
                timeline = anime.timeline({
                    easing: 'easeInOutQuad'
                });

                // First: expand banner width
                card.classList.add('is-active');

                // After SUMMARY_FADE_DELAY: fade in summary
                if (summary) {
                    timeline.add({
                        targets: summary,
                        opacity: 1,
                        duration: SUMMARY_FADE_DURATION,
                        delay: SUMMARY_FADE_DELAY
                    });
                }
            };

            const pause = () => {
                video.pause();

                // Kill any existing timeline
                if (timeline) timeline.pause();

                // Create timeline: first hide summary, then collapse banner
                timeline = anime.timeline({
                    easing: 'easeInOutQuad',
                    complete: () => {
                        card.classList.remove('is-active');
                    }
                });

                // First: fade out summary
                if (summary) {
                    timeline.add({
                        targets: summary,
                        opacity: 0,
                        duration: SUMMARY_FADE_DURATION_OUT
                    });
                }
            };

            // Use hoverintent instead of direct event listeners
            hoverintent(card, HOVERINTENT_DURATION, play, pause);
        }
    }
}